import React, { useState, useEffect } from 'react'

import Modal from './Modal'

export default function ModalContainer({component: Component}) {
    return (
        <>
            {Component && <Modal  component={Component} />}  
        </>
    )
}
